export default __webpack_public_path__ + "static/media/excavator_second_hand_for_sale.07e44b47.png";